import React, {useEffect, useState} from 'react'
import VerifyPaymentForm from './VerifyPaymentForm'
import {
  useGetPaymentMethodsQuery,
  useGetPaymentSessionQuery
} from '../../services/guestCheckinApi'
import LoadingSpinner, {LoadingSpinnerSize} from '../common/LoadingSpinner'
import StepLabel from '../common/StepLabel'
import VerifyPaymentStatus from './VerifyPaymentStatus'
import CheckinCheckmark from '../../assets/checkin-checkmark.png'
import CheckinError from '../../assets/checkin-error.png'
import {ReservationCheckin} from '../../types'
import {faCircleRight} from '@fortawesome/free-regular-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {getPropertyConfig} from '../../services/propertyContext'
import VerifyPaymentTerminal from './VerifyPaymentTerminal'

interface VerifyPaymentProps {
  reservationCheckin: ReservationCheckin
  onNext: Function
}

enum ViewState {
  Form = 'Form',
  FormLoading = 'FormLoading',
  Terminal = 'Terminal',
  StatusLoading = 'StatusLoading',
  Complete = 'Complete',
  Error = 'Error'
}

const VerifyPayment = ({onNext, reservationCheckin}: VerifyPaymentProps) => {
  const [viewState, setViewState] = useState(ViewState.Form)
  const paymentMethodsQuery = useGetPaymentMethodsQuery(null)
  const paymentSessionQuery = useGetPaymentSessionQuery(null)
  const paymentSessionId = paymentSessionQuery.data?.id
  const reservation = reservationCheckin?.reservation
  const {paymentTerminalEnabled} = getPropertyConfig()

  console.log('paymentTerminalEnabled', paymentTerminalEnabled)

  useEffect(() => {
    if (reservation?.paymentAccount?.isActive) {
      setViewState(ViewState.Complete)
    } else if (paymentTerminalEnabled) {
      setViewState(ViewState.Terminal)
    } else if (
      paymentMethodsQuery.isLoading ||
      !paymentMethodsQuery.data ||
      paymentSessionQuery.isLoading ||
      !paymentSessionQuery.data
    ) {
      setViewState(ViewState.FormLoading)
    } else if (paymentMethodsQuery.data && paymentSessionQuery.data) {
      setViewState(ViewState.Form)
    } else {
      setViewState(ViewState.Error)
    }
  }, [reservation, paymentMethodsQuery.data, paymentSessionQuery.data])

  if (viewState === ViewState.Terminal) {
    return (
      <section className="flex flex-col items-center justify-start mt-12">
        <StepLabel label="3" />
        <h1 className="header-2 font-semibold">Add Credit Card</h1>
        <div className="m-8 w-1/2">
          <VerifyPaymentTerminal
            onPaymentCompleted={() => {
              setViewState(ViewState.StatusLoading)
            }}
            onPaymentError={() => {
              setViewState(ViewState.Error)
            }}
          />
        </div>
      </section>
    )
  } else if (viewState === ViewState.FormLoading) {
    return (
      <div className="h-full flex justify-center items-center gap-2">
        <LoadingSpinner size={LoadingSpinnerSize.Large} />
        <div>Loading...</div>
      </div>
    )
  } else if (viewState === ViewState.Form) {
    return (
      <section className="flex flex-col items-center justify-start mt-12">
        <StepLabel label="3" />
        <h1 className="header-2 font-semibold">Add Credit Card</h1>
        <div className="m-8 w-1/2">
          <VerifyPaymentForm
            paymentMethods={paymentMethodsQuery.data}
            paymentSession={paymentSessionQuery.data}
            isSavedPayment={true}
            onPaymentCompleted={() => {
              setViewState(ViewState.StatusLoading)
            }}
            onPaymentError={() => {
              setViewState(ViewState.Error)
            }}
          />
        </div>
      </section>
    )
  } else if (viewState === ViewState.StatusLoading) {
    return (
      <VerifyPaymentStatus
        paymentSessionId={paymentSessionId}
        onComplete={(isVerified: boolean) => {
          if (isVerified) {
            setViewState(ViewState.Complete)
          } else {
            setViewState(ViewState.Error)
          }
        }}
      />
    )
  } else if (viewState === ViewState.Complete) {
    return (
      <section className="w-full flex flex-col items-center justify-start gap-8 mt-12">
        <StepLabel label="3" />
        <h1 className="header-2 font-semibold">Payment Method Added</h1>
        <img src={CheckinCheckmark} className="h-52" />
        <button
          className="btn btn-secondary btn-wide font-bold text-xl"
          onClick={() => onNext()}
        >
          <FontAwesomeIcon icon={faCircleRight} />
          <span>continue</span>
        </button>
      </section>
    )
  } else if (viewState === ViewState.Error) {
    return (
      <div className="flex flex-col items-center justify-start gap-8 mt-12">
        <StepLabel label="3" />
        <h1 className="header-2 font-semibold">Payment Method Failed</h1>
        <img src={CheckinError} className="h-52" />
        <a
          className="link link-primary"
          onClick={() => {
            setViewState(ViewState.FormLoading)

            // create a new payment session
            paymentSessionQuery.refetch()
          }}
        >
          Please try again
        </a>
      </div>
    )
  } else {
    return <></>
  }
}

export default VerifyPayment
